import { CouponTypeEnum } from 'common/enums/CouponTypeEnum'
import { calculateShippingTotal } from 'common/utils/price-calculator'
import { useSelectedOfferPricing } from 'publisher/pages/offer-page/hooks/useSelectedOfferPricing'
import { usePayment } from 'publisher/store'
import {
  getActivePricePlan,
  getCheckedBump,
  getCheckedCoupon,
  getProduct,
  getProductActiveVariant,
  getSelectedShipping,
} from 'publisher/store/payment/paymentSelectors'

/**
 * @returns final payment amount for selected products (digital and physical) and shipping cost combined in cents
 */
export const useFinalAmount = () => {
  const product = usePayment(getProduct)
  const activeProductVariant = usePayment(getProductActiveVariant)
  const pricePlan = usePayment(getActivePricePlan)
  const bump = usePayment(getCheckedBump)
  const bumpPlan = bump?.pricePlans ? bump.pricePlans[0] : null
  const productBump = bump?.product ?? null
  const coupon = usePayment(getCheckedCoupon)

  const selectedPricing = useSelectedOfferPricing({
    selectedProduct: product,
    selectedPricePlan: pricePlan,
    activeProductVariant,
  })
  const selectedBumpPricing = useSelectedOfferPricing({
    selectedProduct: productBump,
    selectedPricePlan: bumpPlan,
  })
  const selectedShipping = usePayment(getSelectedShipping)
  const shippingTotal = selectedShipping
    ? calculateShippingTotal(selectedShipping, selectedPricing?.taxPercent ?? 0)
    : 0

  const totalGrossAmount =
    (selectedPricing?.grossAmount ?? 0) +
    (selectedBumpPricing?.grossAmount ?? 0)

  const isFullyPaidByCoupon =
    (coupon?.discountType === CouponTypeEnum.Percent &&
      coupon.discountAmount === 100) ||
    (coupon?.discountType === CouponTypeEnum.Fixed &&
      coupon.discountAmount >= (selectedPricing?.originalAmount ?? 0))

  if (isFullyPaidByCoupon) {
    return 0
  }

  // temp solution, we need to use backend calculations https://systeme-team.slack.com/archives/C03MZQ0J26N/p1740474129691919
  return Math.ceil((totalGrossAmount ?? 0) + shippingTotal)
}
